import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { LogoMark } from "../components/chat/Logo";
import { adminApi, errorText } from "../lib/admin";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await adminApi.post("/auth/login", { email, password });
      nav("/admin", { replace: true });
    } catch (err) {
      setError(errorText(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ad-page grid place-items-center px-5">
      <motion.form onSubmit={submit} className="ad-card w-full max-w-sm p-7" data-testid="admin-login-form"
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <LogoMark size={84} />
        <h1 className="ad-h1 mt-5">Painel de cliques</h1>
        <p className="text-sm text-[#9DB0A5] mt-1 flex items-center gap-1.5"><Lock size={13} /> Acesso restrito ao administrador</p>
        <label className="ad-label mt-6">E-mail</label>
        <input data-testid="admin-login-email" type="email" required value={email} autoComplete="username"
          onChange={(e) => setEmail(e.target.value)} className="ad-input" />
        <label className="ad-label mt-4">Senha</label>
        <input data-testid="admin-login-password" type="password" required value={password} autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value)} className="ad-input" />
        {error && <p data-testid="admin-login-error" className="text-sm text-[#FF7A7A] mt-3">{error}</p>}
        <button data-testid="admin-login-submit" disabled={loading} className="ad-btn mt-6 w-full">
          {loading ? <Loader2 size={18} className="animate-spin" /> : "Entrar"}
        </button>
      </motion.form>
    </div>
  );
}
